import atypes from '../actions/actionTypes';
import * as _ from 'lodash';
import { errorTemplate, getError } from './utils';


const _authTemplate = {
    login: false,
    profile: {},
    error: errorTemplate(),
    apiVersion: {},
    loading: true,
};

function newState() {
    return {
        ..._.cloneDeep(_authTemplate)
    }
}

// Response about user is login or not.
export default function(state = newState(), action) {
    switch (action.type) {
        case atypes.LOGIN_REQUEST:{
            return {
                ...state,
                login: false,
                error: errorTemplate(),
            }
        }
        case atypes.LOGIN_SUCCESS:
            return {
                ...state,
                login: true,
                error: errorTemplate(),
            };
        case atypes.LOGIN_FAILURE:{
            return {
                ...state,
                login: false,
                error: getError(action.payload, 'Failed to login.'),
            }
        }

        case atypes.LOAD_USER_PROFILE_REQUEST:{
            return {
                ...state,
                error: errorTemplate(),
            }
        }
        case atypes.LOAD_USER_PROFILE_SUCCESS:{
            return {
                ...state,
                login: true,
                profile: action.payload,
                error: errorTemplate(),
            }
        }
        case atypes.LOAD_USER_PROFILE_FAILURE:{
            return {
                ...state,
                login: true,
                error: getError(action.payload, 'Failed to load user profile.'),
            }
        }
        case atypes.SHOW_VERSION_REQUEST: {
            return {
                loading: true,
                apiVersion: {},
                error: errorTemplate(),
            }
        }
        case atypes.SHOW_VERSION_SUCCESS: {
            return {
                loading: false,
                apiVersion: action.payload,
            }
        }
        case atypes.SHOW_VERSION_FAILURE: {
            return {
                ...state,
                loading: false,
                error: getError(action.payload, 'Failed to get version information.')
            }
        }
        case atypes.NO_TOKEN_FOUND: {
            return {
                error: getError(action.payload, 'Token not found.')
            }
        }
        default:
            return state;
    }
}
